import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { QRCodeSVG } from "qrcode.react";
import api from "@/lib/api";
import WalletButtons from "@/components/WalletButtons";
import { Ticket, MapPin, Clock, Calendar as CalendarIcon } from "lucide-react";

/**
 * Mobile-optimierte Ticketseite (Web-Wallet-Fallback).
 * Public — kein Login nötig, aufgerufen via Wallet-URL.
 */
export default function WebTicket() {
  const { ticketId } = useParams();
  const [t, setT] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    api.get(`/tickets/${ticketId}`).then(({ data }) => setT(data))
      .catch((e) => setError(e.response?.data?.detail || "Ticket nicht gefunden"));
  }, [ticketId]);

  if (error) return (
    <div className="min-h-screen bg-[#050505] text-[#F5F0E6] flex items-center justify-center p-4">
      <div className="text-center">
        <Ticket size={48} className="mx-auto text-[#EE9CA1] mb-3" />
        <div className="text-lg">{error}</div>
      </div>
    </div>
  );
  if (!t) return <div className="min-h-screen bg-[#050505] text-[#F5F0E6] flex items-center justify-center p-4">Lade …</div>;

  const qr = t.qr_code || t.ticket_number || t.id;
  const dateStr = (t.date || "").split("-").reverse().join(".");

  return (
    <div className="min-h-screen bg-gradient-to-b from-[#050505] to-[#0F0F0F] text-[#F5F0E6] flex items-center justify-center p-4">
      <div className="w-full max-w-md" data-testid="web-ticket-page">
        <div className="text-center mb-6">
          <div className="text-[10px] uppercase tracking-[0.5em] text-[#D4AF37]">Kinoticket</div>
          <h1 className="font-heading text-3xl mt-1">THE MOVIE HOUSE</h1>
        </div>

        <div className="card-lux p-6 relative">
          {/* Perforation-Optik */}
          <div className="absolute left-0 -translate-x-1/2 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-[#050505]" />
          <div className="absolute right-0 translate-x-1/2 top-1/2 -translate-y-1/2 w-6 h-6 rounded-full bg-[#050505]" />

          <div className="text-center pb-4 border-b border-dashed border-[#2A2A2A]">
            <div className="text-[10px] uppercase tracking-widest text-[#A8A398]">Vorstellung</div>
            <div className="font-heading text-2xl mt-1 text-[#EEDC82]">{t.movie_title || "Film"}</div>
          </div>

          <div className="py-4 space-y-2 text-sm border-b border-dashed border-[#2A2A2A]">
            <div className="flex items-center justify-between"><span className="text-[#A8A398] flex items-center gap-1"><CalendarIcon size={11} />Datum</span><span className="font-mono">{dateStr}</span></div>
            <div className="flex items-center justify-between"><span className="text-[#A8A398] flex items-center gap-1"><Clock size={11} />Beginn</span><span className="font-mono">{t.start_time}</span></div>
            <div className="flex items-center justify-between"><span className="text-[#A8A398] flex items-center gap-1"><MapPin size={11} />Saal</span><span className="font-mono">{t.hall}</span></div>
            <div className="flex items-center justify-between"><span className="text-[#A8A398]">Platz</span><span className="font-mono text-[#D4AF37]">Reihe {t.row} · Sitz {t.seat}</span></div>
          </div>

          <div className="pt-6 flex flex-col items-center">
            <div className="bg-white p-3 rounded-lg">
              <QRCodeSVG value={qr} size={200} bgColor="#FFFFFF" fgColor="#000000" level="M" />
            </div>
            <div className="mt-3 text-[10px] text-[#575148] uppercase tracking-widest font-mono">{qr}</div>
            <div className="text-[9px] text-[#575148] mt-1">Beim Einlass zeigen</div>
          </div>
        </div>

        <div className="mt-4">
          <WalletButtons ticketId={t.id} />
        </div>

        <div className="text-center text-[9px] text-[#575148] mt-6 italic">
          Diese Ansicht funktioniert auch offline. Für Apple/Google Wallet: Button oben antippen.
        </div>
      </div>
    </div>
  );
}
